/* eslint-disable no-unneeded-ternary */
import classnames from 'classnames'
import LazyLoad from 'react-lazyload';
import appendCDN from '../../utils/append_cdn_link';

/* eslint-disable prefer-template */
const ImgCdn = (props) => {
  const {
    src,
    alt = '',
    thumb,
    className,
    lazyLoad = true,
    ...rest
  } = props


  return (
    <>
      {lazyLoad ?
        <LazyLoad once>
          <img src={appendCDN(src)} alt={alt} className={classnames('rs-img', className)} {...rest}/>
        </LazyLoad>
        :
        <img src={appendCDN(src)} alt={alt} className={classnames('rs-img', className)} {...rest}/>
      }
      {/* {loaded === false && <img src={appendCDN(thumb)} alt={alt} />} */}
    </>
  )
}

export default ImgCdn
